import { setErrorMsg } from '../utils/wz.v2'

/*
错误码定义

4*****: Api请求类错误
5*****: App对接类错误

Api请求错误： 参数，路径等错误
41Xxx： 通用参数错误
41XxxYyy{3,5}：Yyy为协议编号长度3至5位，不够3位的协议号前面补零

Api响应错误（超时，返回数据非法等）
1xxxx，2xxxx: 后端返回的错误码，目前固定1或2开头的5位数字
42Xxx： 通用响应错误
42XxxYyy{3,5}：特定协议响应错误，Yyy为协议编号，长度3至5位

App请求错误（参数，路径等错误）
51Xxx： 通用参数错误码
51XxxYyy{3,5}：特定Api请求错误

App响应错误：超时，返回数据非法等
52Xxx： 通用响应错误
52XxxYyy{3,5}：特定协议响应错误

上述编号的格式中：
Xxx： 表示错误编号，3位长度
Yyy{3,5}：表示协议编号，长度3至5位，不够3位的协议号前面补零

*/
export const NO_ERROR = 0 // 无错误

export const ERR_REP = 42000  // 请求参数错误


// server errorCode
export const ERR_REP_NOT_LOGIN = 10018 // 未登录


function errorDefine (list) {
    return list.reduce(
        (acc, cur) => {
            acc[0][cur[0]] = cur[1]
            if (cur[2]) {
                acc[1][cur[2]] = cur[0]
            }
            return acc
        },
        [{}, {}]
    )
}

export const [ERROR_MESSAGE, ERROR] = errorDefine([
    [10696, '超过账户余额，请重新填写提现金额'],
    [10359, '您还未实名认证，无法使用该功能'],
    [10141, '目标对象不存在'],
    [10140, '未检测到设备号'],
    [10138, '此股票已经存在于自选股中'],
    [10137, '获取自选股列表失败'],
    [10136, '删除自选股失败'],
    [10135, '没有这条自选股信息'],
    [10134, '没有自选股'],
    [10133, '获取自选股失败'],
    [10132, '数据未生成'],
    [10131, '昵称一个月修改一次'],
    [10130, '添加自选股失败'],
    [10129, '昵称一个月只能修改一次'],
    [10127, '用户未登录王者家园'],
    [10124, '直播信息不存在'],
    [10123, '没有赞过'],
    [10122, '没有权限赞当前对象'],
    [10121, '已经赞过了'],
    [10120, '不是合法的token'],
    [10119, 'ucid不存在'],
    [10118, '内容包含禁止使用的字符'],
    [10117, '用户名不符合规范'],
    [10116, '昵称不符合规范'],
    [10115, '暂时无可用nick'],
    [10114, '昵称已经被使用'],
    [10113, '生成同步码失败'],
    [10112, 'ucenter未同步'],
    [10111, '同步ucid失败'],
    [10110, 'ucenter已经同步'],
    [10109, '没有权限评论当前对象'],
    [10108, 'token已过期'],
    [10107, '数据库记录不存在'],
    [10106, '不存在未支付的发货订单'],
    [10105, '无法修改已支付的金额'],
    [10104, '不支持的第三方登录'],
    [10103, '绑定状态已失效，请重试！'],
    [10102, '没有这条记录'],
    [10101, '搜索条件不成立'],
    [10100, '查询的订单状态不正确'],
    [10099, '要删除的订单不存在'],
    [10098, '没有相关的orderId'],
    [10097, '需要修改的信息不存在'],
    [10096, '购买渠道字段错误'],
    [10095, '没有权限查看'],
    [10094, '插入数据失败'],
    [10093, '没有需要更新的字段'],
    [10092, 'mobile字段长度超过预设值'],
    [10091, 'tel字段长度超过预设值'],
    [10090, 'zipcode字段长度超过预设值'],
    [10089, 'address字段长度超过预设值'],
    [10088, 'email字段长度超过预设值'],
    [10087, '新手机号验证码错误'],
    [10086, '旧手机号号验证码错误'],
    [10085, '支付已取消，请重新下单'],
    [10084, '支付正在处理中，请稍后查看'],
    [10082, '缺少uuid'],
    [10081, '已经预定本期大礼包'],
    [10080, '大礼包还没有预定'],
    [10079, '还没有新建收货地址'],
    [10078, '新增收货地址失败'],
    [10077, '没有获取到uid'],
    [10076, '没有获取到区列表'],
    [10075, '没有获取到省列表'],
    [10074, '缺少fUid'],
    [10073, '没有返回相关信息'],
    [10072, '没有获取到uid'],
    [10071, '删除头像失败'],
    [10070, '没有相册信息'],
    [10069, '缺少albumId'],
    [10068, '上传头像格式不正确'],
    [10067, '上传头像失败'],
    [10066, '无法创建用户头像相册'],
    [10065, ''],
    [10064, '请求失败'],
    [10063, '请输入验证码'],
    [10062, '没有收到验证码或是验证码错误'],
    [10061, '此账号已被其他王者财经账号绑定'],
    [10060, '绑定信息已经过期，请重新申请绑定'],
    [10059, '生成验证码出错'],
    [10058, '没有获取相应的mobCoutry或mobile'],
    [10057, '用户名或者密码有误'],
    [10056, '新旧密码一样'],
    [10055, '密码长度有误'],
    [10054, '字段没有更新'],
    [10053, '收货地址太多'],
    [10050, '获取数据失败'],
    [10048, '已经注册'],
    [10047, '不正确的注册来源'],
    [10045, 'consignee字段长度超过预设范围'],
    [10044, '请求不存在'],
    [10043, '初始化失败'],
    [10042, '安全性检测失败'],
    [10041, 'httpCode返回为非200'],
    [10040, '没有相关的addressId'],
    [10039, '解绑信息不正确'],
    [10038, '第三方绑定已经失效'],
    [10037, '未能从数据库获取信息'],
    [10036, '未能获取到信息'],
    [10035, '邮箱绑定链接已失效'],
    [10034, '系统邮件发送方信息不存在'],
    [10033, '消息发送失败'],
    [10032, '邮箱已经被使用了'],
    [10031, '生成二维码出错'],
    [10030, '绑定时无法完成注册'],
    [10029, '用户已取消绑定，请重新绑定'],
    [10028, '绑定平台不存在'],
    [10027, '更新用户名失败'],
    [10026, '更新用户基础信息失败'],
    [10025, '生日数值不合法'],
    [10024, '性别数值不合法'],
    [10023, '待更新的字段不存在'],
    [10021, '手机号已经被使用了'],
    [10020, '用户名已经被使用了'],
    [10019, '用户名只能修改一次'],
    [10018, '用户未登录'],
    [10017, '非法的verify'],
    [10016, '登录设备已切换，请重新登录'],
    [10015, 'verify已经过期'],
    [10014, '登录失败次数过多，请稍后重试'],
    [10013, '手机号不存在或者密码不正确'],
    [10012, '重复获取验证码'],
    [10011, '密码长度不符合要求'],
    [10010, '昵称长度超过设定值'],
    [10009, '错误的手机号国家代码'],
    [10008, '验证码错误，或者已经过期'],
    [10007, '服务器内部错误（无法确定操作是否完成），请稍后再试'],
    [10006, '手机号已经注册'],
    [10005, '缺少必要的参数或者传入的参数有误'],
    [10004, '操作速度太快了,稍后重试'],
    [10003, '不允许重复操作'],
    [10002, '没有权限操作'],
    [10001, '目标对象不存在'],
    [10723, '直播间已关闭(10723)']
])

setErrorMsg(ERROR_MESSAGE)